export class GraphApiInnerError {
	public static parse(data: IGraphApiInnerError): GraphApiInnerError {
		const innerError: GraphApiInnerError = new GraphApiInnerError();
		if ((data['request-id'] !== undefined) && (data['request-id'] != null)) {
			innerError.requestId = data['request-id'];
		}
		if ((data.date !== undefined) && (data.date != null)) {
			innerError.date = new Date(data.date);
		}
		return innerError;
	}

	public requestId: string = '';
	public date: Date = new Date();
}

export interface IGraphApiInnerError {
	'request-id'?: string;
	date?: string;
}
